import { StateCreator } from "zustand";

// --- State Type ---
export type ProgramSliceState = {
  selectedPhaseId: number | null;
};

// --- Actions Type ---
export type ProgramSliceActions = {
  setSelectedPhaseId: (phaseId: number | null) => void;
};

// --- Combined Type ---
export type ProgramSlice = ProgramSliceState & ProgramSliceActions;

// --- Initial State ---
export const initialProgramState: ProgramSliceState = {
  selectedPhaseId: null,
};

// --- Slice Creator ---
export const createProgramSlice: StateCreator<
  ProgramSlice,
  [],
  [],
  ProgramSlice
> = (set) => ({
  ...initialProgramState,

  setSelectedPhaseId: (phaseId) => set({ selectedPhaseId: phaseId }),
});

// --- Selectors ---
export const program = {
  selectedPhase: (s: ProgramSlice) => ({
    id: s.selectedPhaseId,
    setId: s.setSelectedPhaseId,
  }),
};

